'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InjectedIframeHTML = function (_Component) {
  _inherits(InjectedIframeHTML, _Component);

  function InjectedIframeHTML() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InjectedIframeHTML);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InjectedIframeHTML.__proto__ || Object.getPrototypeOf(InjectedIframeHTML)).call.apply(_ref, [this].concat(args))), _this), _this.handleLoad = function (event) {
      console.log('iframe loaded', event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InjectedIframeHTML, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var doc = this._iframe.contentDocument;
      doc.open();
      doc.write(this.props.data.redirectOutput.html);
      doc.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          iframeProps = _props.iframeProps;

      return _react2.default.createElement('iframe', _extends({
        ref: function ref(node) {
          return _this2._iframe = node;
        },
        frameBorder: '0',
        width: '100%',
        height: data.redirectOutput.height,
        onLoad: this.handleLoad
      }, iframeProps));
    }
  }]);

  return InjectedIframeHTML;
}(_react.Component);

exports.default = InjectedIframeHTML;